module.exports = __webpack_public_path__ + "img/article-7.06fbdc1d.jpg";